import { defineComponent as _defineComponent } from 'vue'
import { materialGroupsService } from '@/services/materialGroups.service';
import { MaterialGroup } from '@/models/materialGroup';
import { Customer } from '@/models/tenant';
import { materialsService } from '@/services/materials.service';
import TableActionButton from '@/components/tableWithActions/TableActionButton.vue';
import TableWithActions from '@/components/tableWithActions/TableWithActions.vue';
import { dialogService } from '@/library-services/dialog.service';
import { onMounted, reactive, ref } from 'vue';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'MaterialGroupModal',
  props: {
    customer: null,
    materialGroups: null,
    materialGroupId: null,
    disabled: { type: Boolean, default: false }
  },
  emits: ['save', 'close'],
  setup(__props: any, { emit }) {

const props = __props as { customer: Customer, materialGroups: MaterialGroup[], materialGroupId: number, disabled: boolean };





const { t } = useI18n();
const materialGroup = reactive(MaterialGroup.GetEmpty());
const isLoading = ref(false);

onMounted(() => {
  refreshData();
});

function closeModal() {
  emit('close');
}

async function refreshData() {
  isLoading.value = true;
  materialGroupsService
    .getDetails(props.materialGroupId)
    .then((data: MaterialGroup) => {
      Object.assign(materialGroup, data);
    })
    .finally(() => (isLoading.value = false));
}

function confirmUnassign(id: number, name: string): void {
  dialogService.confirmWithPromise({
    title: t('dialog.confirm_title').toString(),
    message: t('material.dialog.unassign').toString() + ` <b>${name}</b>?`,
    confirmText: t('dialog.confirm_unassign').toString(),
    cancelText: t(`dialog.confirm_cancel`).toString(),
    type: 'is-danger',
    onConfirm: async () => await unassignMaterial(id),
  });
}

async function unassignMaterial(id: number) {
  await materialsService.unassign(id).then(() => {
    materialGroup.materials = materialGroup.materials.filter(
      (x) => x.id !== id,
    );
  });
}

return { __sfc: true,props, emit, t, materialGroup, isLoading, closeModal, refreshData, confirmUnassign, unassignMaterial, TableActionButton, TableWithActions }
}

})